function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import moment from 'moment';
export var getYears = function getYears(start, end) {
  var years = [];
  var current = moment(start);

  while (end > current || current.format('YYYY') === end.format('YYYY')) {
    years.push({
      year: current.format('YYYY'),
      start: current.format('YYYY') === start.format('YYYY') ? start : moment(current).startOf('year'),
      end: current.format('YYYY') === end.format('YYYY') ? end : moment(current).endOf('year')
    });
    current.add(1, 'year');
  }

  return years;
};
export var getMonths = function getMonths(start, end) {
  var months = [];
  var current = moment(start);

  while (end > current || current.format('YYYY-MM') === end.format('YYYY-MM')) {
    months.push({
      year: current.format('YYYY'),
      month: current.format('MM'),
      start: current.format('YYYY-MM') === start.format('YYYY-MM') ? start : moment(current).startOf('month'),
      end: current.format('YYYY-MM') === end.format('YYYY-MM') ? end : moment(current).endOf('month')
    });
    current.add(1, 'month');
  }

  return months;
};
export var getDays = function getDays(start, end) {
  var days = [];
  var current = moment(start);

  while (end > current || current.format('D') === end.format('D')) {
    days.push({
      year: current.format('YYYY'),
      month: current.format('MM'),
      day: current.format('DD'),
      start: current.format('YYYY-MM-DD') === start.format('YYYY-MM-DD') ? start : moment(current).startOf('day'),
      end: current.format('YYYY-MM-DD') === end.format('YYYY-MM-DD') ? end : moment(current).endOf('day')
    });
    current.add(1, 'day');
  }

  return days;
};
export var getHours = function getHours(start, end) {
  var hours = [];
  var current = moment(start);

  while (end > current || current.format('HH') === end.format('HH')) {
    hours.push({
      year: current.format('YYYY'),
      month: current.format('MM'),
      day: current.format('DD'),
      hour: current.format('HH'),
      start: current.format('YYYY-MM-DD-HH') === start.format('YYYY-MM-DD-HH') ? start : moment(current).startOf('hour'),
      end: current.format('YYYY-MM-DD-HH') === end.format('YYYY-MM-DD-HH') ? end : moment(current).endOf('hour')
    });
    current.add(1, 'hour');
  }

  return hours;
};
export var getMinutes = function getMinutes(start, end) {
  var minutes = [];
  var current = moment(start);

  while (end > current || current.format('mm') === end.format('mm')) {
    minutes.push({
      year: current.format('YYYY'),
      month: current.format('MM'),
      day: current.format('DD'),
      hour: current.format('HH'),
      minute: current.format('mm'),
      start: current.format('YYYY-MM-DD-HH-mm') === start.format('YYYY-MM-DD-HH-mm') ? start : moment(current).startOf('minute'),
      end: current.format('YYYY-MM-DD-HH-mm') === end.format('YYYY-MM-DD-HH-mm') ? end : moment(current).endOf('minute')
    });
    current.add(1, 'minute');
  }

  return minutes;
};
/**
 *
 * @param {Moment} periodStart - visible periodLimit
 * @param {Moment} periodEnd - visible periodLimit
 * @param {Moment} periodLimitStart - visible periodLimit
 * @param {Moment} periodLimitEnd - visible periodLimit
 */

export var getPeriodLimits = function getPeriodLimits(periodStart, periodEnd, periodLimitStart, periodLimitEnd) {
  var periodStartMom = moment(periodStart);
  var periodEndMom = moment(periodEnd);
  var periodLimitStartMom = moment(periodLimitStart);
  var periodLimitEndMom = moment(periodLimitEnd);
  var periodLimitsCfg = [];

  if (periodLimitStartMom.isBefore(periodStartMom)) {
    periodLimitsCfg.push({
      key: 'before',
      start: periodLimitStartMom,
      end: periodStartMom
    });
  }

  if (periodLimitEndMom.isAfter(periodEndMom)) {
    periodLimitsCfg.push({
      key: 'after',
      start: periodEndMom,
      end: periodLimitEndMom
    });
  }

  return periodLimitsCfg;
};
/**
 *
 * @param {Moment} periodStart - visible periodLimit
 * @param {Moment} periodEnd - visible periodLimit
 * @param {Array} overlays
 *  overlay.label
 *  overlay.key
 *  overlay.classes
 *  overlay.height
 *  overlay.backdroundColor
 *  overlay.top
 */

export var getOverlays = function getOverlays(periodStart, periodEnd, overlays) {
  var periodLimitStart = moment(periodStart);
  var periodLimitEnd = moment(periodEnd);
  var overlaysCfg = [];

  var _iterator = _createForOfIteratorHelper(overlays),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var overlay = _step.value;
      var start = moment(overlay.start);
      var end = moment(overlay.end);

      if (end.isAfter(periodLimitStart) && start.isBefore(periodLimitEnd)) {
        overlaysCfg.push({
          label: overlay.label,
          hideLabel: overlay.hideLabel,
          key: overlay.key,
          classes: overlay.classes,
          height: overlay.height,
          top: overlay.top || 0,
          backgound: overlay.backdroundColor,
          start: start.isBefore(periodLimitStart) ? periodLimitStart : start,
          end: end.isAfter(periodLimitEnd) ? periodLimitEnd : end,
          origin: overlay
        });
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return overlaysCfg;
};